import mime from 'mime-types';

const FileType = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  PDF: 'pdf',
  FILE: 'file',
};

const BYTES_IN_MB = 1000000;
// Shared cap for message, broadcast and community uploads; nothing compresses before upload.
const MAX_FILE_UPLOAD_SIZE = 100000000;
const MAX_FILE_UPLOAD_SIZE_MB = MAX_FILE_UPLOAD_SIZE / BYTES_IN_MB;

// Gets the mime type and then returns the first part of it (audio, video, application, etc...)
const getFileType = (type) => {
  const mimeType = mime.contentType(type);
  if (mimeType) {
    const processedType = mimeType.split('/')[0];
    return Object.values(FileType).includes(processedType) ? processedType : FileType.FILE;
  }

  return FileType.FILE;
  // The mime-types package returns false when the input is not valid
};

export {
  FileType,
  getFileType,
  MAX_FILE_UPLOAD_SIZE,
  MAX_FILE_UPLOAD_SIZE_MB,
};
